export const PHONE_DISPLAY = "06 20 243 5165";
export const PHONE_TEL = "tel:+36202435165";
export const EMAIL_DISPLAY = "lomil8212@gmail.com";
export const EMAIL_URL = `mailto:lomil8212@gmail.com?subject=${encodeURIComponent("Kanapé elszállítás – árajánlat kérés")}`;
export const SERVICE_AREA = "Budapest és 30 km-es körzete";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FLOOR_OPTIONS = [
  "Földszint / kertes ház",
  "1–2. emelet, van lift",
  "1–2. emelet, nincs lift",
  "3–4. emelet, van lift",
  "3–4. emelet, nincs lift",
  "5. emelet vagy feljebb",
];

export const IMAGES = {
  hero: [
    { src: "https://images.unsplash.com/photo-1601467995997-ac1ae9a8fff4?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80", label: "Tiszta szállítóautó", alt: "Tiszta fehér szállító teherautó a ház előtt" },
    { src: "https://images.unsplash.com/photo-1657049199023-87fb439d47c5?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80", label: "Lépcsőház, lift nélkül", alt: "Csapat nehéz, becsomagolt bútort visz" },
    { src: "https://images.unsplash.com/photo-1630699375895-fe5996d163ee?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80", label: "Üres, tiszta szoba", alt: "Kiürített, tiszta szoba világos padlóval" },
  ],
  services: [
    "https://images.unsplash.com/photo-1590635023142-73c3d34f2805?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.unsplash.com/photo-1769972557854-7eae6f95585b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    "https://images.pexels.com/photos/257636/pexels-photo-257636.jpeg?auto=compress&w=1200",
  ],
};
